export function getRuntimeUserId({
  appSlug = 'app',
  explicitUserId,
  storage = typeof localStorage !== 'undefined' ? localStorage : null,
  randomUUID = typeof crypto !== 'undefined' ? crypto.randomUUID?.bind(crypto) : null,
} = {}) {
  if (explicitUserId) {
    return String(explicitUserId);
  }

  const storageKey = `promptaas:${appSlug}:runtime_user_id`;
  const existing = storage?.getItem?.(storageKey);
  if (existing) {
    return existing;
  }

  const randomPart = randomUUID
    ? randomUUID()
    : `${Date.now().toString(36)}${Math.random().toString(36).slice(2)}`;
  const anonymousId = `anon_${randomPart}`;
  storage?.setItem?.(storageKey, anonymousId);
  return anonymousId;
}
